import { config } from '@app/config';
import { Chip, useMediaQuery, useTheme } from '@mui/material';
import { useBreakpointsDown } from '../../core/hooks/useBreakpointsDown';
import { useBreakpointsUp } from '../../core/hooks/useBreakpointsUp';

/**
 * Renders a chip in the top-right showing the current MUI breakpoint (xs, sm, md, lg, xl).
 * Only visible in development mode.
 * On click, logs all up and down breakpoint matches to the console.
 */
export function BreakpointChip() {
  const theme = useTheme();
  const up = useBreakpointsUp();
  const down = useBreakpointsDown();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  const breakpoint = isXl ? 'xl' : isLg ? 'lg' : isMd ? 'md' : isSm ? 'sm' : 'xs';

  const handleClick = () => {
    console.log('Breakpoints up:', up);
    console.log('Breakpoints down:', down);
  };

  if (!config.isNodeDev) {
    return null;
  }

  return (
    <Chip
      label={breakpoint}
      onClick={handleClick}
      size="small"
      color="secondary"
      variant="outlined"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999000,
        opacity: 1,
      }}
    />
  );
}
